import { object, string, number } from 'yup';
import { MetaData } from 'models/MetaData/metaData.model';
export interface CategoryOptions {
  value: number | undefined;
  label: string | undefined;
  key: string | number | undefined;
}
export interface CategoryOptionsCompanyType {
  value: string | undefined;
  label: string | undefined;
  key: string | number | undefined;
}
interface ItemProps {
  label: string;
  value: string;
}
const CompanyType: ItemProps[] = [
  {
    label: 'CPG',
    value: 'CPG',
  },
  {
    label: 'CPG & Wholesale',
    value: 'CPG & Wholesale',
  },
  {
    label: 'Food Service',
    value: 'Food Service',
  },
  {
    label: 'Co-Packer',
    value: 'Co-Packer',
  },
];
const memberFoodAssociation = [
  {
    label: 'Protein Industries Canada',

    value: 'Protein Industries Canada',
  },

  {
    label: 'Alberta Food Processing Association',

    value: 'Alberta Food Processing Association',
  },

  {
    label: 'Canadian Food Innovation Network',

    value: 'Canadian Food Innovation Network',
  },
];
const referral = [
  {
    label: 'Search Engine',
    value: 'Search Engine',
  },
  {
    label: 'LinkedIn',
    value: 'LinkedIn',
  },
  {
    label: 'Twitter',
    value: 'Twitter',
  },
  {
    label: 'Instagram',
    value: 'Instagram',
  },

  {
    label: 'Recommended by a friend or colleague',
    value: 'Recommended by a friend or colleague',
  },

  {
    label: 'Industry Association',
    value: 'Industry Association',
  },
  {
    label: 'Advertisement',
    value: 'Advertisement',
  },
  {
    label: 'Website',
    value: 'Website',
  },
  {
    label: 'Events/seminars',
    value: 'Events/seminars',
  },
  {
    label: 'Direct mail',
    value: 'Direct mail',
  },

  {
    label: 'Other',
    value: 'Other',
  },
];
export const revenue_range: ItemProps[] = [
  {
    label: '0 - 500k',
    value: '0 - 500k',
  },
  {
    label: '500k - 1M',
    value: '500k - 1M',
  },

  {
    label: '1M - 2M',
    value: '1M - 2M',
  },

  {
    label: '2M - 5M',
    value: '2M - 5M',
  },

  {
    label: '5M - 10M',
    value: '5M - 10M',
  },

  {
    label: 'Over 10M',
    value: 'Over 10M',
  },
];

export const Fields = [
  {
    name: 'companyName',
    placeholder: 'Company name',
    label: 'Company Name',
  },
  {
    name: 'companyType',
    placeholder: 'Company Type',
    label: 'Company Type',
    select: true,
    selectOptions: CompanyType,
  },
  {
    name: 'revenuerange',
    placeholder: 'Revenue range',
    label: 'Revenue range',
    select: true,
    selectOptions: revenue_range,
  },
  {
    name: 'associationMember',
    placeholder: 'Member of any Industry Associations',
    label: 'Member of any Industry Associations',
    select: true,
    selectOptions: memberFoodAssociation,
  },
  {
    name: 'source',
    placeholder: 'How did you hear about us',
    label: 'How did you hear about us',
    select: true,
    selectOptions: referral,
  },
];
export const validationSchema = object({
  companyName: string().nullable().required('Required'),
  companyType: string().nullable().required('Required'),
  revenuerange: string().nullable().required('Required'),
  // associationMember: string().required('Required'),
  source: string().nullable().required('Required'),
});
export const initialValues = {
  companyName: '',
  companyType: undefined,
  revenuerange: undefined,
  associationMember: undefined,
  source: undefined,
  image: '',
};

export const convertToOptions = (data: MetaData[]) => {
  const options: CategoryOptions[] = [];
  data?.map((item: MetaData) => {
    options.push({
      label: item.name,
      value: item.id,
      key: item.id,
    });
  });
  return options;
};

export const convertToOptionsCompanyType = (data: MetaData[]) => {
  const options: CategoryOptionsCompanyType[] = [];
  data?.map((item: MetaData) => {
    options.push({
      label: item.name,
      value: item.name,
      key: item.id,
    });
  });
  return options;
};

export const CompanyDetailsFormMetas = {
  REVENUE_RANGE: 'revenue_range',
  REFERRAL: 'referral',
  ACCOUNT_COMPANY_TYPE: 'account_company_type',
};
